import "./Status_Pop.css";

function Status_Pop(props)
{
    const inductions = document.getElementsByClassName("inductions")[0];
    function closeStatusPop()
    {
        const pop_close = document.getElementsByClassName("status_pop")[0];
        inductions.removeChild(pop_close);
        props.redirect();
    }

    const pop = document.createElement("div");
    const img = document.createElement("img");
    const break_tag = document.createElement("br");
    const spacer_01 = document.createElement("div");
    const spacer_02 = document.createElement("div");
    const close = document.createElement("img");
    const description = document.createElement("h1");
    pop.setAttribute("class", "status_pop");
    spacer_01.setAttribute("class", "spacer_01");
    spacer_02.setAttribute("class", "spacer_02");
    close.setAttribute("class", "close");
    img.src = props["status"] == "STATUS OK" ? "/Resources/Success_Mark.jpg" : "/Resources/Failure_Mark.jpg";
    close.src = "/Resources/Close_Image.png";
    description.innerText = props.status;
    pop.appendChild(close);
    pop.appendChild(spacer_02);
    pop.appendChild(img);
    pop.appendChild(break_tag);
    pop.appendChild(spacer_01);
    pop.appendChild(description);
    inductions.appendChild(pop);
    close.onclick = closeStatusPop;
}

export default Status_Pop;